import { SxStyleProp } from 'theme-ui';

export const hidden: SxStyleProp = {
  width: '0.1px',
  height: '0.1px',
  opacity: 0,
  overflow: 'hidden',
  position: 'absolute',
  zIndex: '-1'
};

export const centeredContent: SxStyleProp = {
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center'
};

export const fullSize: SxStyleProp = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
